// @flow
import { CLAIM_HUB } from '~/core/state/install-hub/constants';
import { DATE_TIME_INTERVAL } from './constants';
import { devices } from '~/core/constants';
import { find } from 'lodash/fp';
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { logIn } from '~/core/state/application/actions';
import { RECEIVE_DEVICES } from '~/core/state/devices/constants';

const actionHandlers = {
    // $FlowFixMe
    [CLAIM_HUB]: handleReduce(state => state.set('hasHub', true)),
    // $FlowFixMe
    [DATE_TIME_INTERVAL]: handleReduce((state, { payload }) => state.set('currentTime', payload)),
    // $FlowFixMe
    [logIn.toString()]: handleReduce((state, { payload: { user } }) => state.set('timezone', user.timezone)),
    [RECEIVE_DEVICES]: handleReduce((state, { payload }) => {
        const hub = find(x => x.type === devices.deviceTypes.HUB, payload);
        const nextState = state.set('hasHub', !!hub);
        return hub ? nextState.set('pmzStatus', hub.props.pmz) : nextState;
    })
};

export default handleActions(
    actionHandlers,
    fromJS({
        currentTime: undefined,
        hasHub: undefined,
        timezone: undefined
    })
);



// WEBPACK FOOTER //
// ./src/core/state/hub/index.js